import { render, staticRenderFns } from "./CategoryDetail.vue?vue&type=template&id=34c4eb55&scoped=true&"
import script from "./CategoryDetail.vue?vue&type=script&lang=js&"
export * from "./CategoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c4eb55",
  null
  
)

export default component.exports